__turbopack_context__.v({
  "icon": "SettingsIcon-module__Aqy77G__icon",
});
